<template><div><dt-stack gap="600" class="d-mbs-600">
  <div class="d-d-grid d-g-600 d-g-cols1 md:d-g-cols3 d-ai-center">
    <div>
      <p class="d-docsite--paragraph">Type sizing is based off of a relative scale, with 16px type as the baseline for body copy and for scaling type.</p>
    </div>
    <div class="d-gc2">
      <svg-loader name="type--in-marketing" class="d-bar-500" />
    </div>
  </div>
  <div>
    <h3 class="d-docsite--header-3">When to use Sans vs Mix </h3>
    <p class="d-docsite--paragraph">When type setting a headline, consider the use case, and use the appropriate option between Season Mix, or Season Sans.</p> <p class="d-docsite--paragraph">Overall, Season Sans should be used the bulk of the time ~80%, with Mix being used for special use cases.</p>
  </div>
  <dt-stack direction="row" gap="400" class="d-ai-flex-start">
    <dt-stack gap="50" class="d-w100p">
      <svg-loader name="type--marketing-sample-01" class="d-mbe-200 d-bar-500" />
      <h3 class="d-docsite--header-4 d-m-0" style="font-size:20px !important">Aspirational, Top-Level</h3>
      <p class="d-docsite--paragraph" style="font-size: 16px;"><strong>Season Mix</strong> for top of the funnel, more aspirational, lofty or abstract headlines, use Season Mix.</p>
    </dt-stack>
    <dt-stack gap="50" class="d-w100p">
      <svg-loader name="type--marketing-sample-02" class="d-mbe-200 d-bar-500" />
      <h3 class="d-docsite--header-4 d-m-0" style="font-size:20px !important">Concrete, Mid-Level</h3>
      <p class="d-docsite--paragraph" style="font-size: 16px;"><strong>Season Sans</strong> for mid of the funnel, more concrete, mid-level headlines, use Season Sans.</p>
    </dt-stack>
  </dt-stack>
  <svg-loader name="type--marketing-sample-03" class="d-bar-500" />
</dt-stack>
</div></template>


